const countryCodes = {
  da: 'da',
  en: 'en',
  da_DK: 'da-DK'
}
export default countryCodes
